import {IconProps} from "../../types/IconProps";

export const DeactivateAllIcon = ({ width = 800, color = '#000'}: IconProps) => {
    return (
        <svg width={`${width}px`} height={`${width}px`} viewBox="0 0 24 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 6L13.5 6M20 6L17.75 6" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
            <path d="M11 16H3" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
            <path d="M15 16L20 11M20 16L15 11" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M11 11L7 11M3 11H4.2" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
        </svg>
    )
}